// import Avatar from '../Avatar'
import { Avatar } from "@material-ui/core";
import { UserCard } from "../Card";
import Notifications from "../../pagecomponents/Notification/Notifications";
import { notificationsData } from "../../pagecomponents/Notification/notificationData";
import withBadge from "../../badge/withBadge";
import { GiHealthNormal } from "react-icons/gi";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  MdExitToApp,
  MdHome,
  MdNotificationsActive,
  MdNotificationsNone,
  MdPersonPin,
} from "react-icons/md";
import {
  ListGroup,
  ListGroupItem,
  Nav,
  Navbar,
  NavItem,
  NavLink,
  Popover,
  PopoverBody,
} from "reactstrap";
import bn from "../../utils/bemnames";
import { getUser } from "../../utlis";
import PersonIcon from "@material-ui/icons/Person";
import OutsideClickHandler from "react-outside-click-handler";
import useHook from "./useHook";
import { getNotificationsPopOver } from "../../pagecomponents/HomePage/action";
import { isNull } from "lodash";
const bem = bn.create("header");
const MdNotificationsActiveWithBadge = withBadge({
  size: "md",
  color: "primary",
  style: {
    top: -10,
    right: -10,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
  },
  count: 10,
  // children: <small>{}</small>,
})(MdNotificationsActive);
const Header = (props) => {
  const [state, setState] = React.useState({
    isOpenNotificationPopover: false,
    isNotificationConfirmed: false,
    isOpenUserCardPopover: false,
    name: "",
    groupAdmin: "",
    palikaName: "",
  });
  const dispatch = useDispatch();

  const toggleNotificationPopover = () => {
    setState({
      ...state,
      isOpenNotificationPopover: !state.isOpenNotificationPopover,
    });

    if (!state.isNotificationConfirmed) {
      setState({ ...state, isNotificationConfirmed: true });
    }
  };

  const toggleUserCardPopover = () => {
    setState({
      ...state,
      isOpenUserCardPopover: !state.isOpenUserCardPopover,
    });
  };
  //   const handleClick = (e)=>{
  //     console.log("click")
  //     if(ref.current && !ref.current.contains(e.target))
  //     {
  //       console.log("hello")
  //         setState({...state,isOpenNotificationPopover:false})
  //     }
  // }
  //   useEffect(()=>{
  //     if(state.isOpenNotificationPopover){
  //       console.log("open notification")
  //       document.addEventListener("mousedown",handleClick,true);
  //       return ()=> document.removeEventListener("mousedown",handleClick,true)
  //     }
  //   },[state])
  const [popOverNotification, setPopOverNotification] = useState(null);
  useEffect(() => {
    var user = getUser();
    console.log(user, "the user is");

    console.log("after disptach");
    if (user) {
      getPopPOverNotification(user._id);
      if (user.groups.includes("PALIKAADMIN")) {
        const groupAdmin = user.groups;
        const name = user.palikaId.palika;
        console.log(name, "name ");
        setState({ ...state, name, groupAdmin });
      }
      if (user.groups.includes("WARDADMIN")) {
        const groupAdmin = user.groups;
        const name = user.ward.ward;
        console.log(name, "name ");
        console.log(user, "the ward admin is");
        setState({
          ...state,
          name,
          groupAdmin,
          palikaName: user.palikaId.palika,
        });
      }
    }
  }, []);

  const getPopPOverNotification = async (id) => {
    const resp = await dispatch(getNotificationsPopOver(id, "all", 0, 3));
    if (resp) {
      console.log(resp, "the resp");
      setPopOverNotification(resp.value.data);
    }
  };

  const logoutHandler = () => {
    console.log("logout");
    localStorage.removeItem("user");
    window.location.replace("/login");
  };
  const { isNotificationConfirmed } = state;
  console.log("header", props);
  // console.log(state.name, "name of header");

  const display = () => {
    if (state.groupAdmin.includes("PALIKAADMIN")) {
      return (
        <span
          style={{
            fontSize: "1.5rem",
            borderRadius: "3px",
            display: "flex",
            justifyContent: "center",
            fontWeight: "550",
            color: "#0066ff",
          }}
          className=" can-click"
        >
          Palika:{state.name}
        </span>
      );
    }
    if (state.groupAdmin.includes("WARDADMIN")) {
      return (
        <a href="/" style={{ textDecoration: "none" }}>
          <span
            style={{
              fontSize: "1.5rem",
              borderRadius: "3px",
              display: "flex",
              justifyContent: "center",
              fontWeight: "550",
              color: "#0066ff",
            }}
            className=" can-click"
          >
            वार्ड नं:{state.name}
          </span>
        </a>
      );
    }
  };
  return (
    <Navbar light expand className={bem.b("bg-white")}>
      <Nav
        style={{ alignItems: "center", fontSize: "1.5rem" }}
        className="text-secondary can-click"
      >
        <span style={{ color: "#0066ff", fontWeight: "550" }}>
          {state.palikaName}
        </span>
      </Nav>
      <Nav navbar className="mr-2" style={{ margin: "0 auto" }}>
        {display()}
      </Nav>

      <Nav navbar className={bem.e("nav-right")}>
        <NavItem className="d-inline-flex">
          <NavLink className="position-relative">
            <a href="/">
              <MdHome size={25} className="text-secondary can-click" />
            </a>
          </NavLink>
          <NavLink id="Popover1" className="position-relative">
            {isNotificationConfirmed ? (
              // <OutsideClickHandler onOutsideClick={()=> setState({...state,isOpenNotificationPopover:false})}>
              <MdNotificationsNone
                size={25}
                className="text-secondary can-click"
                onClick={() => toggleNotificationPopover()}
              />
            ) : (
              <MdNotificationsActiveWithBadge
                size={25}
                className="text-secondary can-click animated swing infinite"
                onClick={() => toggleNotificationPopover()}
              />
            )}
          </NavLink>

          <Popover
            placement="bottom"
            isOpen={state.isOpenNotificationPopover}
            toggle={() => toggleNotificationPopover()}
            target="Popover1"
          >
            <OutsideClickHandler
              onOutsideClick={() =>
                setState({ ...state, isOpenNotificationPopover: false })
              }
            >
              <PopoverBody>
                <a
                  href="/viewall"
                  style={{ textDecorationLine: "none", color: "#991ad9" }}
                >
                  View all
                </a>
                <br />
                <Notifications
                  notificationsData={popOverNotification}
                  isActive={state.isNotificationConfirmed}
                />
              </PopoverBody>
            </OutsideClickHandler>
          </Popover>
        </NavItem>
        <NavItem>
          <NavLink id="Popover2">
            <Avatar onClick={() => toggleUserCardPopover()}>
              {/* <img src={user.photo} width="100%" /> */}
            </Avatar>
          </NavLink>
          <Popover
            placement="bottom-end"
            isOpen={state.isOpenUserCardPopover}
            toggle={() => toggleUserCardPopover()}
            target="Popover2"
            className="p-0 border-0"
            style={{ minWidth: 250 }}
          >
            <OutsideClickHandler
              onOutsideClick={() =>
                setState({ ...state, isOpenUserCardPopover: false })
              }
            >
              <PopoverBody className="p-0 border-light">
                <UserCard
                  title={getUser() ? getUser().username : ""}
                  subtitle={getUser() ? getUser().fullname : ""}
                  className="border-light"
                >
                  <ListGroup flush>
                    {/* <ListGroupItem tag="button" action className="border-light">
                        <MdPersonPin /> Profile
                    </ListGroupItem> */}
                    <a href="/viewprofile" style={{ textDecoration: "none" }}>
                      <ListGroupItem
                        tag="button"
                        action
                        className="border-light"
                      >
                        <AssignmentIndIcon /> Profile
                      </ListGroupItem>
                    </a>
                    <ListGroupItem
                      tag="button"
                      action
                      className="border-light"
                      onClick={() => logoutHandler()}
                    >
                      <MdExitToApp /> Signout
                    </ListGroupItem>
                  </ListGroup>
                </UserCard>
              </PopoverBody>
            </OutsideClickHandler>
          </Popover>
        </NavItem>
      </Nav>
    </Navbar>
  );
};

export default Header;
